import { lazyRetry } from '@bimser/core';
import * as React from 'react';
import IAppMainProps from '../app-main/entities/IAppMainProps';

const AppMainContainerLazy = React.lazy(() =>
	lazyRetry(
		() =>
			import(/* webpackChunkName: "web-startup" */ '../app-main/containers/AppMainContainer')
	)
);
function AppMainContainer(props: IAppMainProps) {
	return (
		<React.Suspense fallback={<></>}>
			<AppMainContainerLazy {...props} />
		</React.Suspense>
	);
}

const MainApp = () => <AppMainContainer />;

export default MainApp;
